// @flow
import * as React from 'react';
import MultiCreatableSelect from 'components/MultiCreatableSelect';
import { updateObject } from 'utils/functional';
import Field from './Field';

const MultiCreatableSelectField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label?: string,
  description?: string
}) => (
  <Field
    inputProps={updateObject(props)}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <MultiCreatableSelect
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default MultiCreatableSelectField;
